<template>
  <div>
    <top-nav></top-nav>
    <div class="top_con">
      <div class="center_container display_flex t_b">
        <!--        <div class="display_flex b_item" @click="toPage('/club')">-->
        <!--          <img alt="" src="../assets/image/index/icon1.png">-->
        <!--          <div class="i_right">-->
        <!--            <div class="r_b">职业俱乐部</div>-->
        <!--            <div>Professional club</div>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="display_flex b_item" @click="toPage('/venueReservation')">-->
        <!--          <img alt="" src="../assets/image/index/icon2.png">-->
        <!--          <div class="i_right">-->
        <!--            <div class="r_b">场馆预定</div>-->
        <!--            <div>Venue booking</div>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="display_flex b_item" @click="toPage('/eventActivities')">-->
        <!--          <img alt="" src="../assets/image/index/icon3.png">-->
        <!--          <div class="i_right">-->
        <!--            <div class="r_b">赛事报名</div>-->
        <!--            <div>Event registration</div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <div class="center_container">
      <!-- 最新新闻、通知公告 -->
      <div class="display_flex info">
        <div class="info_left">
          <el-carousel arrow="never" height="560px" indicator-position="none">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <img :src="fileUrl + item.fileUrl" alt="" style="width: 100%;height: 100%">
            </el-carousel-item>
          </el-carousel>
          <!--          <img :src="fileUrl + activeUrl" alt="">-->
        </div>
        <div class="info_right">
          <el-tabs v-model="activeName" @tab-click="getPage()">
            <!--            <el-tab-pane label="最新新闻" name="3"></el-tab-pane>-->
            <el-tab-pane label="通知公告" name="1"></el-tab-pane>
            <el-tab-pane label="媒体聚集" name="2"></el-tab-pane>
            <el-tab-pane label="新闻资讯" name="3"></el-tab-pane>
            <el-tab-pane label="赛事活动" name="5"></el-tab-pane>
          </el-tabs>
          <div class="more_style" @click="moreClick">更多</div>
          <div>
            <div v-for="(item, index) in xwList" :key="index" class="hover_style list_item"
                 @click="$router.push({
                    path:'/sportsDetails',
                    query:{
                      item:JSON.stringify(item)
                    }
                 })">
              <div class="text_overflow item_title">{{ item.title }}</div>
              <div class="item_date">{{ item.createTime }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 推荐场馆 -->
      <div class="cg">
        <div class="title">推荐场馆</div>
        <div class="cg_con">
          <div class="cg_left">
            <div v-for="item in cgCity" :key="item.id" :class="{ 'sel_item': currentCityId === item.id }"
                 class="l_item" @click="cgClick(item.id)">
              {{ item.name }}
            </div>
          </div>
          <div class="display_flex cg_right">
            <div v-for="item in cgList" :key="item.id" class="hover_style r_item" style="height: 100%"
                 @click="toPage('/venueDetail', {id:item.id})">
              <img :src="fileUrl+imageChange(item.pics)" alt="" class="i_img">
              <div class="i_info">
                <div class="text_overflow i_name">
                  {{ item.name }}
                </div>
                <div class="text_overflow i_add">
                  <img alt="" src="../assets/image/index/icon_local.png">
                  {{ item.address }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 热门赛事、近期活动 -->
      <div class="hot_con">
        <div class="display_flex hot_title">
          <div v-for="(item, index) in hotTitle" :key="index"
               :style="{'fontWeight': currentTitleIndex === index ? 700 : 400}"
               @click="currentTitleIndex = index">
            {{ item }}
          </div>
        </div>
        <div class="display_flex hot_list">
          <div v-for="item in hotList" :key="item.id" class="hover_style h_item ss_style" style="height: 490px;"
               @click="toPage('/eventDetails',{item:JSON.stringify(item)})">
            <img :src="fileUrl + item.imageUrl" alt="" class="i_img">
            <div class="i_info">
              <div class="text_overflow i_title">{{ item.name }}</div>
              <div style="height: 35px">比赛时间：{{ item.gameStartTime | dateFormat }} 至 {{
                  item.gameEndTime | dateFormat
                }}
              </div>
              <div style="height: 35px">比赛地点：{{ item.gameLocation }}</div>
              <div style="text-align: center;margin-top: 20px">
                <el-button type="primary">立即报名</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <bot-nav></bot-nav>
  </div>
</template>

<script>
import { FILE_API } from "@/Settings"
import moment from 'moment'

export default {
  name: "index",
  data () {
    return {
      fileUrl: FILE_API,
      bannerList: [],

      activeName: '1',
      // 新闻
      xwList: [],

      // 场馆城市
      cgCity: [],
      currentCityId: 1, // 当前场馆城市id
      // 场馆
      cgList: [],

      // 热门赛事、近期活动
      hotTitle: ['热门赛事'],
      currentTitleIndex: 0, // 当前选中title下标
      hotList: [],
      activeUrl: ''
    }
  },
  created () {
    this.getBannerList()
    this.getArea()
    this.getManagementPage()
    this.getPage()
  },
  filters: {
    dateFormat (val) {
      return moment(val).format('YYYY-MM-DD')
    }
  },
  methods: {
    // banner
    getBannerList () {
      this.$postAction('/gateway/banner/list').then(res => {
        if (res.code === 0) {
          this.bannerList = res.data
        }
      })
    },
    // 新闻
    getPage () {
      this.$postAction('gateway/health-counseling/getPage', {
        "page": {
          "current": this.current,
          "size": 5
        },
        "data": {
          "type": this.activeName,
          "keyword": ""
        }
      }).then((res) => {
        this.xwList = res.data.records
        this.activeUrl = this.xwList.length > 0 && this.xwList[0].imageUrl
      })
    },
    // 场馆切换
    cgClick (id) {
      this.currentCityId = id
      this.menhuAjax()
    },
    moreClick () {
      this.$router.push('/sportsInformation')
    },
    // 图品转化
    imageChange (url) {
      let imgList = url && url.split(',')
      return imgList && imgList[0]
    },
    // 省市区
    getArea () {
      this.$postAction('dict-area/tree').then((res) => {
        this.cgCity = res.data[0].children
        this.currentCityId = this.cgCity[0].id
        this.menhuAjax()
      })
    },
    // 场馆
    menhuAjax () {
      this.$postAction('gateway/venue-table/menhu_page', {
        "page": {
          "current": this.current,
          "size": 3
        },
        "data": {
          "cityId": this.currentCityId,
          "areaId": null,
          "projectId": 0
        }
      }).then((res) => {
        this.cgList = res.data.records
      })
    },
    // 热门赛事
    getManagementPage () {
      this.$postAction('gateway/event-management/getManagementPage', {
        "page": {
          "current": this.current,
          "size": 4
        },
        "data": {
          "type": 0
        }
      }).then((res) => {
        this.hotList = res.data.records
      })
    },
    toPage (path, query) {
      this.$router.push({
        path: path,
        query: query
      })
    }
  }
}
</script>

<style lang="less" scoped>
.top_con {
  position: relative;

  .c_img {
    width: 100%;
  }

  .t_b {
    position: absolute;
    left: 50%;
    bottom: 25px;
    transform: translateX(-50%);
    justify-content: center;
    z-index: 10;

    .b_item {
      width: calc((100% - 20px) / 2);
      justify-content: start;
      background: rgba(0, 0, 0, .5);
      padding: 37px 30px;
      cursor: pointer;
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }

      img {
        margin-right: 24px;
      }

      .i_right {
        font-size: 24px;
        color: #FFFFFF;

        .r_b {
          font-weight: 700;
          font-size: 32px;
          margin-bottom: 15px;
        }
      }
    }
  }
}

.center_container {
  padding: 65px 0;

  .info {
    align-items: normal;

    .info_left {
      width: 50%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .info_right {
      margin-left: 60px;
      width: calc(50% - 60px);
      position: relative;

      .list_item {
        margin-top: 30px;
        padding: 10px 0;
        border-radius: 5px;

        &:first-child {
          margin-top: 9px;
        }

        &:hover {
          padding: 10px 20px;
        }

        .item_title {
          font-size: 24px;
          margin-bottom: 12px;
        }

        .item_date {
          font-size: 16px;
          color: #999999;
        }
      }
    }
  }

  .cg {
    margin-top: 80px;

    .title {
      font-weight: 700;
      font-size: 32px;
      color: #0058A6;
      margin-bottom: 56px;
    }

    .cg_con {
      display: flex;
      height: 450px;

      .cg_left {
        width: 180px;
        border-right: 1px solid #979797;
        display: flex;
        flex-direction: column;
        align-items: end;
        justify-content: space-between;
        padding: 24px 0;
        height: 100%;
        overflow-y: auto;

        .l_item {
          padding-right: 30px;
          width: 135px;
          height: 56px;
          line-height: 56px;
          font-size: 24px;
          color: #999999;
          cursor: pointer;
          text-align: right;

          &:hover {
            font-size: 28px;
          }
        }

        .sel_item {
          background-image: linear-gradient(90deg, #0058a600 0%, #0058a633 100%);
          font-weight: 700;
          position: relative;
          color: #333333;

          &:after {
            content: '';
            position: absolute;
            width: 4px;
            height: 100%;
            background: #0058A6;
            top: 0;
            right: 0;
          }
        }
      }

      .cg_right {
        width: calc(100% - 180px);
        padding-left: 6px;
        justify-content: flex-start;

        .r_item {
          width: calc((100% - 72px) / 3);
          margin-left: 24px;
          border: 1px solid #DCDCDC;

          .i_img {
            width: 100%;
            height: 336px;
            object-fit: cover;
          }

          .i_info {
            padding: 20px 20px 27px;

            .i_name {
              font-weight: 700;
              font-size: 24px;
            }

            .i_add {
              margin-top: 18px;
              font-size: 16px;
              color: #333333;

              img {
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
  }

  .hot_con {
    margin-top: 90px;

    .hot_title {
      font-size: 32px;
      color: #0058A6;
      justify-content: start;

      div {
        margin-right: 80px;
        cursor: pointer;
      }
    }

    .hot_list {
      margin-top: 40px;
      justify-content: start;

      .h_item {
        width: calc((100% - 60px) / 4);
        border: 1px solid #DCDCDC;

        .i_img {
          width: 100%;
          height: 239px;
          object-fit: cover;
        }

        .i_info {
          padding: 18px 20px 16px;
          font-size: 16px;

          div {
            margin-bottom: 10px;
          }

          .i_title {
            font-weight: 700;
            font-size: 24px;
            margin-bottom: 18px;
          }
        }
      }
    }
  }
}

.ss_style {
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }
}

.more_style {
  position: absolute;
  top: 0px;
  right: 0;
  font-size: 16px;
  color: #0058A6;
  height: 56px;
  width: 50px;
  background-color: #fff;
  z-index: 99;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  cursor: pointer;

  &:hover {
    text-shadow: 1px 1px 2px rgba(28, 133, 246, 0.2);
  }
}
</style>
